import { waitUntil } from '@atc/wait-until';

// import directly from getPixall.js so we dont need to mock all utils
import getPixall from './getPixall';
import sendCDLEvent from './sendCDLEvent';
let isPageTagSent = false;
let removePageExitListener = () => {};
function resetIsPageTagSent() {
  isPageTagSent = false;
}
function handleSendEvent(option, pixallData, pixall) {
  // to enable a CDL event set 'useCDL' to true inside the AnalyticsEngine props
  if (option.useCDL) {
    sendCDLEvent({
      cdl: pixallData.cdl
    });
  } else {
    pixall.push(pixallData);
  }
}
export default async function ensurePixallPageLoadAndSendEvent(option, pixallData, _temp) {
  let {
    history = {},
    isPageEvent = false
  } = _temp === void 0 ? {} : _temp;
  const pixall = await getPixall(option);
  const {
    skipPageEvent = false,
    onPageEventSent = () => {},
    numberOfEvents = 2
  } = option;
  const {
    ignorePageTag = false
  } = pixallData;
  try {
    if (isPageEvent) {
      removePageExitListener();
      isPageTagSent = true;

      // legacy support
      if (history.listen) {
        removePageExitListener = history.listen(resetIsPageTagSent);
      }

      // eventListener support
      if (history.eventListener) {
        const {
          on = () => {},
          off = () => {},
          pageExitEvent = ''
        } = history.eventListener;
        on(pageExitEvent, resetIsPageTagSent);
        removePageExitListener = () => {
          off(pageExitEvent, resetIsPageTagSent);
        };
      }
      handleSendEvent(option, pixallData, pixall);
      if (onPageEventSent && typeof onPageEventSent === 'function') {
        waitUntil(() => window?.Pixall?.isPageLoadSent(), () => {
          onPageEventSent('pixall', numberOfEvents);
        }, 30, 15000);
      }
    } else {
      waitUntil(() => isPageTagSent || skipPageEvent || ignorePageTag, () => {
        handleSendEvent(option, pixallData, pixall);
      }, 30, 15000);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Pixall: Failed to Send Event: ', error);
  }
}